<template>
    <div>
        <m-assembly-table ref='pageForm'
                        needScrollBar
                        needSticky
                        columnDrag
                        thDrag
                        :formData='formData'
                        :columns='columnsFilter'
                        :data='tableData'
                        :tableButtons='tableButtons'
                        :loading='loading'
                        :currentPage='settings.currentPage'
                        :pageSize='settings.pageSize'
                        :total='settings.total'
                        :settings='settings'
                        :height="600"
                        @onSubmit='onSubmit'
                        @onPageSizeChange='onPageSizeChange'
                        @onCurrentPageChange='onPageChange'
                        @onSelectionChange="onSelectionChange"
        >
        <div slot="button" style="margin-bottom:10px;">
            <Button class="mr10" type="primary" size="small" :loading="loading" :disabled="selection.length === 0" @click="moreBeforePrint">{{$t('DeliveryOrderQuery.t1')}}</Button>
            <Button class="mr10" type="primary" size="small" :loading="loading" :disabled="selection.length === 0" @click="matchReport">{{$t('processInspectionSearch.t96')}}</Button>
            <Button class="mr10" type="primary" size="small" :loading="loading" :disabled="selection.length === 0" @click="toMaterialLabel">{{$t('DeliveryOrderQuery.t4')}}</Button>
            <Button v-if="carPlateNumSetting.isCar" class="mr10" type="primary" size="small" :loading="loading" :disabled="selection.length === 0" @click="maintainCarPlateNum">{{this.$t('DeliveryOrderQuery.t52')}}</Button>
            <Button class="mr10" type="primary" size="small" @click="exportExcel" :loading="loading">{{$t('DeliveryOrderQuery.t6')}}</Button>
            <Button class="mr10" type="primary" size="small" @click="goInvoice">{{$t('DeliveryOrderQuery.t58')}}</Button>
            <template v-if="deliverySwitch">
                <Button class="mr10" type="primary" size="small" :loading="loading" :disabled="selection.length === 0" @click="submitShipping">{{$t('发货清单提交')}}</Button>
                <Button class="mr10" type="primary" size="small" :loading="loading" :disabled="selection.length === 0" @click="cancelShipping">{{$t('发货清单取消')}}</Button>
                <Button class="mr10" type="primary" size="small" :loading="loading" @click="deliveryListModalOpen">{{$t('打印发货清单')}}</Button>
            </template>
            <set-table class="mr10" :columns="columns.columns" buttonSize="small" @setTableUpdate="setTableUpdate"></set-table>
        </div>
        </m-assembly-table>

        <!--厂区----------------------------------------------------- -->
        <Modal
            v-model="locationSetting.show"
            :width="locationSetting.modalWidth"
            :title="locationSetting.modalTitle"
        >
            <Collapse value="1">
                <Panel name="1">&nbsp;&nbsp;<b>{{$t('page.assemblyTable.searchCondition')}}</b>&nbsp;<Icon
                    type="search"></Icon>
                    <div slot="content">
                        <span style="margin-left:30px;">{{$t('page.assemblyTable.searchCondition')}}</span>
                        <Select style="width:150px;margin-left:15px;" v-model="locationSetting.value">
                            <Option value="1">{{this.$t('DeliveryOrderQuery.t15')}}</Option>
                        </Select>
                        <Input style="width:200px;margin-left:10px;" v-model.trim="locationSetting.inputValue" placeholder="" clearable></Input>
                        <Button type="primary" style="margin-left:30px;" @click="beforeGetDelLocation1">{{this.$t('common.searchBtn')}}</Button>
                        <Button type="primary" style="margin-left: 10px" @click="handleSelect1"
                                :disabled="Object.keys(locationSetting.selectedRow).length === 0 ? true : false">
                            {{this.$t('createDeliveryOrderToInformView.t47')}}
                        </Button>
                    </div>
                </Panel>
            </Collapse>
            <Table :columns="locationSetting.modalTableColumns"
                   :data="locationSetting.modalTableData"
                   border :loading="locationSetting.loading"
                   stripe highlight-row disabled-hover
                   thDrag
            ></Table>
            <div slot="footer">
                <Page :total="locationSetting.modalTotalpages" :page-size="locationSetting.modalPageSize"
                      :current="locationSetting.modalCurrentPage"
                      @on-change="onModalPageChange1"
                      border show-total show-elevator></Page>
            </div>
        </Modal>
        <!--厂区----------------------------------------------------- -->

        <!--子库----------------------------------------------------- -->
        <Modal
            v-model="sublibrarySetting.show"
            :width="sublibrarySetting.modalWidth"
            :title="sublibrarySetting.modalTitle"
        >
            <Collapse value="1">
                <Panel name="1">&nbsp;&nbsp;<b>{{$t('page.assemblyTable.searchCondition')}}</b>&nbsp;<Icon
                    type="search"></Icon>
                    <div slot="content">
                        <span style="margin-left:30px;">{{$t('page.assemblyTable.searchCondition')}}</span>
                        <Select style="width:150px;margin-left:15px;" v-model="sublibrarySetting.value">
                            <Option value="1">{{this.$t('DeliveryOrderQuery.t16')}}</Option>
                        </Select>
                        <Input style="width:200px;margin-left:10px;" v-model.trim="sublibrarySetting.inputValue" placeholder="" clearable></Input>
                        <Button type="primary" style="margin-left:30px;" @click="beforeGetDelLocation2">{{this.$t('common.searchBtn')}}</Button>
                        <Button type="primary" style="margin-left: 10px" @click="handleSelect2"
                                :disabled="Object.keys(sublibrarySetting.selectedRow).length === 0 ? true : false">
                            {{this.$t('createDeliveryOrderToInformView.t47')}}
                        </Button>
                    </div>
                </Panel>
            </Collapse>
            <Table :columns="sublibrarySetting.modalTableColumns"
                   :data="sublibrarySetting.modalTableData"
                   border :loading="sublibrarySetting.loading"
                   stripe highlight-row disabled-hover
                   thDrag
            ></Table>
            <div slot="footer">
                <Page :total="sublibrarySetting.modalTotalpages" :page-size="sublibrarySetting.modalPageSize"
                      :current="sublibrarySetting.modalCurrentPage"
                      @on-change="onModalPageChange2"
                      border show-total show-elevator></Page>
            </div>
        </Modal>
        <!--子库----------------------------------------------------- -->

        <!--车间----------------------------------------------------- -->
        <Modal
            v-model="departmentSetting.show"
            :width="departmentSetting.modalWidth"
            :title="departmentSetting.modalTitle"
        >
            <Collapse value="1">
                <Panel name="1">&nbsp;&nbsp;<b>{{$t('page.assemblyTable.searchCondition')}}</b>&nbsp;<Icon
                    type="search"></Icon>
                    <div slot="content">
                        <span style="margin-left:30px;">{{$t('page.assemblyTable.searchCondition')}}</span>
                        <Select style="width:150px;margin-left:15px;" v-model="departmentSetting.value">
                            <Option value="1">{{this.$t('DeliveryOrderQuery.t16')}}</Option>
                        </Select>
                        <Input style="width:200px;margin-left:10px;" v-model.trim="departmentSetting.inputValue" placeholder="" clearable></Input>
                        <Button type="primary" style="margin-left:30px;" @click="beforeGetDelLocation3">{{this.$t('common.searchBtn')}}</Button>
                        <Button type="primary" style="margin-left: 10px" @click="handleSelect3"
                                :disabled="Object.keys(departmentSetting.selectedRow).length === 0 ? true : false">
                            {{this.$t('createDeliveryOrderToInformView.t47')}}
                        </Button>
                    </div>
                </Panel>
            </Collapse>
            <Table :columns="departmentSetting.modalTableColumns"
                   :data="departmentSetting.modalTableData"
                   border :loading="departmentSetting.loading"
                   stripe highlight-row disabled-hover
                   thDrag
            ></Table>
            <div slot="footer">
                <Page :total="departmentSetting.modalTotalpages" :page-size="departmentSetting.modalPageSize"
                      :current="departmentSetting.modalCurrentPage"
                      @on-change="onModalPageChange3"
                      border show-total show-elevator></Page>
            </div>
        </Modal>
        <!--车间----------------------------------------------------- -->

        <!--车牌号----------------------------------------------------- -->
        <Modal
            v-model="carPlateNumSetting.show"
            :title="carPlateNumSetting.modalTitle"
            :mask-closable="false">
            <Form :model="carPlateNumSetting" label-position="right" ref="carPlateNumSetting" :label-width="110"
                    :rules="carPlateNumSetting.rules">
                <Row :gutter="0">
                    <Col span="24" offset="0">
                        <FormItem :label="this.$t('DeliveryOrderQuery.t53')" prop="inputValue">
                            <Input v-model.trim="carPlateNumSetting.inputValue" placeholder="" clearable></Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="primary" :loading="loading" :disabled="!carPlateNumSetting.inputValue" @click="carPlateNumSettingOk">{{this.$t('common.confirmBtn')}}</Button>
                <Button type="default" style="margin-left:10px;" @click="carPlateNumSetting.show = false">{{this.$t('common.cancelBtn')}}</Button>
            </div>
        </Modal>
        <!--车牌号----------------------------------------------------- -->


        <Modal
            v-model="deliveryListModal.show"
            :title="$t('发货清单打印')"
            :width="800">
            {{ $t('DeliveryOrderQuery.t61') }}：
            <Select v-model="deliveryListModal.deliveryListPrinted" clearable style="width:200px;display:inline-block;">
                <Option value="N">{{this.$t('DeliveryOrderQuery.t63')}}</Option>
                <Option value="Y">{{this.$t('DeliveryOrderQuery.t62')}}</Option>
            </Select>
            <span style="margin-left:10px;">
                {{ $t('发货清单状态') }}：
            </span>
            <Select v-model="deliveryListModal.deliveryListStatus" clearable style="width:200px;display:inline-block;">
                <Option v-for="item in INT_DELIVERY_LIST_STATUS" :label="item.label" :value="item.value" :key="item.value"></Option>
            </Select>
            <Button type="primary" style="margin-left: 10px;" :loading="deliveryListModal.loading" @click="shippingList">{{$t('fpzInvaccCommon.t11')}}</Button>
            <Table
                style="margin-top:10px;"
                border
                :columns="deliveryListModal.columns"
                :data="deliveryListModal.tableData"
                :loading="deliveryListModal.loading">
            </Table>
            <template slot="footer">
                <Button type="default" @click="deliveryListModal.show = false">{{$t('gscInvoice.t20')}}</Button>
                <Button type="primary" style="margin-left:20px;" :disabled="!deliveryListModal.row" :loading="deliveryListModal.loading" @click="exportShippingList">{{$t('ApplyReceiveMgnView.PRINT')}}</Button>
            </template>
        </Modal>

    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import { exportExcel } from '@/utils/tool';
export default {
    name: 'DeliveryOrderQuery',
    components: { 
        mAssemblyTable 
    },
    watch: {
        'deliveryListModal.show'(val) {
            if (val) {
                this.shippingList();
            }
        },
    },
    computed: {
        deliverySwitch() {
            return this.INT_HW_DELIVERY_LIST.some(dict => dict.code === this.orgCode);
        },
        orgCode() {
            return this.getFormDataItemVal(this.formData.items, 'orgCode');
        },
        columnsFilter() {
            return {
                columns: this.columns.columns.filter(item => !(this.deliverySwitch ? [] : ['deliveryListNumber', 'deliveryListStatus']).includes(item.key)),
            };
        },
    },
    data () {
        return {
            INT_HW_DELIVERY_LIST: [],
            deliveryListModal: {
                show: false,
                columns: [
                    {
                        title: ' ',
                        width: 35,
                        align: 'center',
                        render: (h, params) => {
                            return h('Checkbox', {
                                props: {
                                    value: params.row.selected,
                                },
                                on: {
                                    'on-change': (val) => {
                                        this.deliveryListModal.tableData.forEach((item) => {
                                            item.selected = false;
                                        });
                                        params.row.selected = val;
                                        this.deliveryListModal.tableData[params.index] = params.row;
                                        this.deliveryListModal.row = val ? params.row : null;
                                    },
                                },
                            });
                        },
                    },
                    {
                        title: this.$t('index.VendorRegist.vrcolumn188'), // 供应商名称
                        key: 'vendorName',
                        minWidth: 120,
                        tooltip: true,
                    },
                    {
                        title: this.$t('发货批次号'),
                        key: 'deliveryListNumber',
                        minWidth: 120,
                    },
                    {
                        title: this.$t('AIInspection.t7'), // 状态
                        key: 'deliveryListStatus',
                        minWidth: 80,
                        align: 'center',
                        render: (h, params) => {
                            const { deliveryListStatus } = params.row;
                            return h('span', this.INT_DELIVERY_LIST_STATUS.find((item) => item.value === deliveryListStatus)?.label);
                        },
                    },
                    {
                        title: this.$t('送货单个数'),
                        key: 'deliveryOrderCount',
                        minWidth: 80,
                        align: 'right',
                    },
                    {
                        title: this.$t('包含送货单条码'),
                        key: 'deliveryListNumber',
                        minWidth: 110,
                        tooltip: true,
                    },
                    {
                        title: this.$t('包含送货单号'),
                        key: 'allDeliveryNumber',
                        minWidth: 110,
                        tooltip: true,
                    },
                    {
                        title: this.$t('包含物料编码'),
                        key: 'allItemCode',
                        minWidth: 110,
                        tooltip: true,
                    },
                ],
                tableData: [],
                loading: false,
                row: null,
                index: 0,
                deliveryListPrinted: '',
            },
            INT_DELIVERY_LIST_STATUS: [],
            locationSetting: {
                show: false,
                modalWidth: 800,
                modalTitle: this.$t('DeliveryOrderQuery.t15'),
                modalTableColumns: [
                    {
                        title: this.$t('createDeliveryOrderToInformView.t47'),
                        width: 35,
                        align: 'center',
                        render: (h, params) => {
                            return h('Checkbox', {
                                props: {
                                    value: params.row.hasSelected
                                },
                                on: {
                                    'on-change': (selection) => {
                                        params.row.hasSelected = selection;
                                        this.locationSetting.modalTableData[params.index] = params.row;
                                        if (selection) {
                                            this.locationSetting.selectedRow = params.row;
                                            for (let i = 0; i < this.locationSetting.modalTableData.length; i++) {
                                                if (i !== params.index) {
                                                    this.locationSetting.modalTableData[i].hasSelected = false;
                                                }
                                            }
                                        } else {
                                            this.locationSetting.selectedRow = {};
                                        }
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t48'),
                        type: 'index',
                        align: 'center',
                        width: 110
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t15'),
                        key: 'locationCode',
                        align: 'center'
                        // width: 110
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t29'),
                        key: 'description',
                        align: 'center'
                        // width: 110
                    }
                ],
                modalTableData: [],
                modalTotalpages: 0,
                modalPageSize: 8,
                modalCurrentPage: 1,
                loading: false,
                value: '1',
                searchValue: '',  //  搜索的下拉框的值
                searchList: [   //  搜索的下拉框
                    {value: 'locationCode', label: this.$t('DeliveryOrderQuery.t15')}
                ],
                inputValue: '', //  搜索框的输入值
                selectedRow: {},    //  已勾选的行
                rules: {    //  表单验证
                }
            },
            sublibrarySetting: {
                show: false,
                modalWidth: 800,
                modalTitle: this.$t('DeliveryOrderQuery.t16'),
                modalTableColumns: [
                    {
                        title: this.$t('createDeliveryOrderToInformView.t47'),
                        width: 35,
                        align: 'center',
                        render: (h, params) => {
                            return h('Checkbox', {
                                props: {
                                    value: params.row.hasSelected
                                },
                                on: {
                                    'on-change': (selection) => {
                                        params.row.hasSelected = selection;
                                        this.sublibrarySetting.modalTableData[params.index] = params.row;
                                        if (selection) {
                                            this.sublibrarySetting.selectedRow = params.row;
                                            for (let i = 0; i < this.sublibrarySetting.modalTableData.length; i++) {
                                                if (i !== params.index) {
                                                    this.sublibrarySetting.modalTableData[i].hasSelected = false;
                                                }
                                            }
                                        } else {
                                            this.sublibrarySetting.selectedRow = {};
                                        }
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t48'),
                        type: 'index',
                        align: 'center',
                        width: 35
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t16'),
                        key: 'secondaryInventoryName',
                        align: 'center'
                        // width: 110
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t29'),
                        key: 'description',
                        align: 'center'
                        // width: 110
                    }
                ],
                modalTableData: [],
                modalTotalpages: 0,
                modalPageSize: 8,
                modalCurrentPage: 1,
                loading: false,
                value: '1',
                searchValue: '',  //  搜索的下拉框的值
                searchList: [   //  搜索的下拉框
                    {value: 'invName', label: this.$t('DeliveryOrderQuery.t16')}
                ],
                inputValue: '', //  搜索框的输入值
                selectedRow: {},    //  已勾选的行
                rules: {    //  表单验证
                }
            },
            departmentSetting: {
                show: false,
                modalWidth: 800,
                modalTitle: this.$t('DeliveryOrderQuery.t18'),
                modalTableColumns: [
                    {
                        title: this.$t('createDeliveryOrderToInformView.t47'),
                        width: 35,
                        align: 'center',
                        render: (h, params) => {
                            return h('Checkbox', {
                                props: {
                                    value: params.row.hasSelected
                                },
                                on: {
                                    'on-change': (selection) => {
                                        params.row.hasSelected = selection;
                                        this.departmentSetting.modalTableData[params.index] = params.row;
                                        if (selection) {
                                            this.departmentSetting.selectedRow = params.row;
                                            for (let i = 0; i < this.departmentSetting.modalTableData.length; i++) {
                                                if (i !== params.index) {
                                                    this.departmentSetting.modalTableData[i].hasSelected = false;
                                                }
                                            }
                                        } else {
                                            this.departmentSetting.selectedRow = {};
                                        }
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t48'),
                        type: 'index',
                        align: 'center',
                        width: 35
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t18'),
                        key: 'DEPARTMENT_CODE',
                        align: 'center'
                        // width: 110
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t6'),
                        key: 'DESCRIPTION',
                        align: 'center'
                        // width: 110
                    }
                ],
                modalTableData: [],
                modalTotalpages: 0,
                modalPageSize: 8,
                modalCurrentPage: 1,
                loading: false,
                value: '1',
                searchValue: '',  //  搜索的下拉框的值
                searchList: [   //  搜索的下拉框
                    {value: 'departmentCode', label: this.$t('DeliveryOrderQuery.t18')}
                ],
                inputValue: '', //  搜索框的输入值
                selectedRow: {},    //  已勾选的行
                rules: {    //  表单验证
                },
                allRelateData: [],   //跳转维护送货检验之前获取的所有与勾选数据相同itemCode和barCode的数据
                vendorName: '',
            },
            carPlateNumSetting: {
                show: false,
                isCar: false,
                modalWidth: 520,
                modalTitle: this.$t('DeliveryOrderQuery.t52'), // 维护车牌号
                inputValue: '',
                rules: {} //  表单验证
            },
            formData: {
                row: 6,
                items: [
                    {
                        title: this.$t('createDeliveryOrderByOrder.t1'), // 库存组织
                        placeholder: this.$t('supplyRatioQueryTable.organizationHolder'),
                        value: '',
                        field: 'orgCode',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('createDeliveryOrderToInformView.t49')
                            }
                        },
                        methods: {
                            change: (val) => {
                                let curOrgVal = this.formData.items[0].value;
                                this.carPlateNumSetting.isCar = this.INT_VEHICLE_NO.some(item => item.code === curOrgVal);
                                // 判断是否GAT泰国机电送货单打印
                                let isJdEmail = (this.INT_CUX_DELIVERY_TEMPLATE.find(item => item.code === curOrgVal) || {}).email;
                                this.isJdTemplate = isJdEmail === '1';
                                let isJdTAGEmail = (this.INT_CUX_ITEM_TAG_TEMPLATE.find(item => item.code === curOrgVal) || {}).email;
                                this.isJdTAGTemplate = isJdTAGEmail === '1';
                                console.log('isJdTAGEmail:', isJdTAGEmail);
                                console.log('this.isJdTAGTemplate:', this.isJdTAGTemplate);
                                // this.getShipToLoactionByCode(val);
                            }
                        }
                    },
                    {
                        value: moment().subtract(10, 'd').format('YYYY/MM/DD 00:00:00'), // 创建日期
                        field: 'creationDateStart',
                        editable: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('supplierDelivery.createDateMust')
                            }
                        },
                        layout: {
                            row: 1,
                            span: 8,
                            offset: 0
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00',
                            needFormat: false,
                            options: {
                                // disabledDate(date) {
                                //     var dt = new Date();
                                //     dt.setMonth(dt.getMonth() - 12);
                                //     return date && date.valueOf() < dt;
                                // }
                            }
                        },
                        type: 'datePicker',
                        title: this.$t('createDeliveryOrderByOrder.t5'),
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: moment().add(3, 'd').format('YYYY/MM/DD 23:59:59'),
                        field: 'creationDateEnd',
                        editable: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('supplierDelivery.createDateMust')
                            }
                        },
                        style: 'width:100%',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            needFormat: false,
                            options: {
                                // disabledDate(date) {
                                //     var dt = new Date();
                                //     dt.setMonth(dt.getMonth() - 12);
                                //     return date && date.valueOf() < dt;
                                // }
                            }
                        },
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: 'OPEN',
                        field: 'deliveryStatus', // 送货单状态
                        disabled: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('DeliveryOrderQuery.t12')
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change() {
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('DeliveryOrderQuery.t13')
                    },
                    {
                        value: '',
                        field: 'deliveryNumberLike', // 送货单号
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('DeliveryOrderQuery.t14')
                    },
                    {
                        value: '',
                        field: 'locationCode', // 厂区
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        // icon: 'search',
                        // canClick: true,
                        title: this.$t('DeliveryOrderQuery.t15'),
                        click: () => {
                            if (this.$refs.pageForm.$refs.queryForm.validateForm()) {
                                this.locationSetting.show = true;
                            }
                        }
                    },
                    {
                        value: '',
                        field: 'subinventory', // 子库
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        // icon: 'search',
                        // canClick: true,
                        title: this.$t('DeliveryOrderQuery.t16'),
                        click: () => {
                            if (this.$refs.pageForm.$refs.queryForm.validateForm()) {
                                this.sublibrarySetting.show = true;
                            }
                        }
                    },
                    {
                        value: '',
                        field: 'needByDateStart', // 需求日期
                        layout: {
                            row: 3,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('DeliveryOrderQuery.t17'),
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'needByDateEnd',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'departmentCode', // 车间
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        // icon: 'search',
                        // canClick: true,
                        title: this.$t('DeliveryOrderQuery.t18'),
                        click: () => {
                            if (this.$refs.pageForm.$refs.queryForm.validateForm()) {
                                this.departmentSetting.show = true;
                            }
                        }
                    },
                    {
                        value: '',
                        field: 'receivedDateStart', // 接收日期
                        layout: {
                            row: 3,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('DeliveryOrderQuery.t19'),
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'receivedDateEnd',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'formType', // 单据类型
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 4
                        },
                        methods: {
                            change() {
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('DeliveryOrderQuery.t20')
                    },
                    {
                        value: '',
                        field: 'barCodeNumberStart', // 条码号
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 4
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('DeliveryOrderQuery.t23'),
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'barCodeNumberEnd',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 4
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        value: '',
                        field: 'scheduledStartDateStart', // 作业上线日期
                        layout: {
                            row: 4,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('DeliveryOrderQuery.t24'),
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'scheduledStartDateEnd',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 4
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'wipentityNamesStart', // 作业号
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 5
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('DeliveryOrderQuery.t25'),
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'wipentityNamesEnd',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 5
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        value: '',
                        field: 'itemCodeStart', // 物料编码
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 5
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('DeliveryOrderQuery.t26'),
                    },
                    {
                        value: '',
                        title: this.$t('DeliveryOrderQuery.t27'),
                        field: 'itemCodeEnd',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 5
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        value: '',
                        title: this.$t('DeliveryOrderQuery.t28'),
                        field: 'createdBy',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 6
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        value: '',
                        field: 'wipstatus', // 作业状态
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 6
                        },
                        methods: {
                            change: () => {
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('DeliveryOrderQuery.t29'),
                    },
                    {
                        value: '',
                        field: 'customsDeclarationNumberLike',
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 6
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('createDeliveryOrderByOrder.t18')
                    },
                    {
                        value: '',
                        field: 'vehicleNumberLike', // 车牌号
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 6
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('DeliveryOrderQuery.t53')
                    },
                    {
                        value: '',
                        field: 'omsCtn', // 箱号
                        layout: {
                        span: 8,
                        offset: 0,
                        row: 6,
                        },
                        options: {
                        rows: 1,
                        type: 'text',
                        },
                        type: 'text',
                        title: this.$t('DeliveryOrderQuery.t56'),
                    },
                    {
                        value: '',
                        field: 'omsInvoiceNo', // 发票号
                        layout: {
                        span: 8,
                        offset: 0,
                        row: 6,
                        },
                        options: {
                        rows: 1,
                        type: 'text',
                        },
                        type: 'text',
                        title: this.$t('DeliveryOrderQuery.t57'),
                    },
                    {
                        value: '',
                        field: 'poNumber', // 采购订单号
                        layout: {
                        span: 8,
                        offset: 0,
                        row: 6,
                        },
                        options: {
                        rows: 1,
                        type: 'text',
                        },
                        type: 'text',
                        title: this.$t('createDeliveryOrderByOrder.t3'),
                    },
                    {
                        value: 'N',
                        field: 'hasPrint', // 是否已打印
                        layout: {
                        span: 8,
                        offset: 0,
                        row: 6,
                        },
                        methods: {
                        change: () => {
                        },
                        },
                        options: {
                        multiple: false,
                        values: [
                            {
                                label: this.$t('DeliveryOrderQuery.t63'),
                                value: 'N',
                            },
                            {
                                label: this.$t('DeliveryOrderQuery.t62'),
                                value: 'Y',
                            },
                        ],
                        },
                        type: 'select',
                        title: this.$t('DeliveryOrderQuery.t61'),
                    },
			        {
			            value: '',
			            field: 'hasChecked', // 是否已检验
			            layout: {
			                span: 8,
			                offset: 0,
			                row: 6,
			            },
			            methods: {
			                change: () => {
			                },
			            },
			            options: {
			                multiple: false,
			                values: [
			                    {
			                        label: this.$t('processInspectionSearch.t115'),
			                        value: 'Y',
			                    },
			                    {
			                        label: this.$t('processInspectionSearch.t116'),
			                        value: 'N',
			                    },
			                ],
			            },
			            type: 'select',
			            title: this.$t('processInspectionSearch.t114'),
			        },
			        {
			            value: '',
			            field: 'invoiceNumber', // 供方发票号
			            layout: {
				            span: 8,
				            offset: 0,
				            row: 6,
			            },
			            options: {
				            rows: 1,
				            type: 'text',
			            },
			            type: 'text',
			            title: this.$t('DeliveryOrderQuery.t65'),
			        },
			        {
                        hide: () => !this.deliverySwitch,
			            value: '',
			            field: 'deliveryListNumber',
			            layout: {
				            span: 8,
				            offset: 0,
				            row: 6,
			            },
			            options: {
				            rows: 1,
				            type: 'text',
			            },
			            type: 'text',
			            title: this.$t('发货清单号'),
			        },
			        {
                        hide: () => !this.deliverySwitch,
			            value: '',
			            field: 'deliveryListStatus', // 发货清单状态
			            layout: {
			                span: 8,
			                offset: 0,
			                row: 6,
			            },
			            methods: {
			                change: () => {
			                },
			            },
			            options: {
			                multiple: false,
			                values: [],
			            },
			            type: 'select',
			            title: this.$t('发货清单状态'),
			        },
                ]
            },
            columns: {
                columns: [
                    {
                        type: 'selection',
                        width: 35,
                        align: 'center'
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t30'), // 查看标签
                        key: 'intTagFlag',
                        align: 'center',
                        sortable: true,
                        width: this.$i18n.locale === 'en-US' ? 70 : 50,
                        render: (h, params) => {
                            let intTagFlag = params.row.intTagFlag;
                            return h('Icon', {
                                props: {
                                    type: 'ios-circle-filled',
                                    size: 27,
                                    color: '#666666'
                                },
                                style: {
                                    cursor: !intTagFlag ? 'not-allowed' : 'pointer',
                                    color: !intTagFlag ? '#666666' : '#2d8cf0'
                                },
                                nativeOn: {
                                    click: () => {
                                        if (intTagFlag) {
                                            this.beforePrintSingleLabel(params.row);
                                        }
                                    }
                                }
                            });
                        }
                    },
		            {
		                title: this.$t('processInspectionSearch.t1'), // 查看检验
		                key: 'hasMatchReportQty',
		                align: 'center',
		                width: 50,
		                render: (h, params) => {
		                    const { hasMatchReportQty, deliveryQuantity } = params.row;
		                    const isChecked = hasMatchReportQty === Number(deliveryQuantity);
		                    return h('Icon', {
		                        props: {
		                            type: 'ios-circle-filled',
		                            size: 27,
		                            color: '#666666',
		                        },
		                        style: {
		                            // cursor: !isChecked ? 'not-allowed' : 'pointer',
		                            color: !isChecked ? '#666666' : '#2d8cf0',
		                        },
		                        nativeOn: {
		                            click: () => {
		                                // if (isChecked) {
		                                // }
		                            },
		                        },
		                    });
		                }
		            },
                    {
                        title: this.$t('发货清单号'), // 发货清单号
                        key: 'deliveryListNumber',
                        align: 'center',
                        sortable: true,
                        width: this.$i18n.locale === 'en-US' ? 160 : 130,
                    },
                    {
                        title: this.$t('发货清单状态'), // 发货清单状态
                        key: 'deliveryListStatus',
                        align: 'center',
                        sortable: true,
                        width: this.$i18n.locale === 'en-US' ? 160 : 100,
                        render: (h, params) => {
                            const { deliveryListStatus } = params.row;
                            return h('span', deliveryListStatus && this.INT_DELIVERY_LIST_STATUS.find((item) => item.value === deliveryListStatus)?.label);
                        },
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t14'), // 送货单号
                        key: 'deliveryNumber',
                        align: 'center',
                        sortable: true,
                        width: this.$i18n.locale === 'en-US' ? 160 : 100
                    },
                    {
                        title: this.$t('createMaterialLabel.barCodeNo'), // 条码号
                        key: 'barcodeNumber',
                        align: 'center',
                        sortable: true,
                        width: 100
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t55'), // 送货数量
                        key: 'deliveryQuantity',
                        align: 'right',
                        sortable: false,
                        width: this.$i18n.locale === 'en-US' ? 120 : 60,
                        sortMethod: (a, b, type) => {
                            // console.log(a,b ,type);
                            if (type === 'asc') {
                                return parseFloat(a) - parseFloat(b);
                            } else {
                                return parseFloat(b) - parseFloat(a);
                            }
                        }
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t16'), // 子库
                        key: 'subInventory',
                        align: 'center',
                        sortable: true,
                        width: this.$i18n.locale === 'en-US' ? 110 : 60
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t12'), // 物料编码
                        key: 'itemCode',
                        align: 'center',
                        sortable: true,
                        width: 150
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t13'), // 物料描述
                        key: 'itemName',
                        width: 300,
                        tooltip: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t14'), // 单位
                        key: 'primaryUom',
                        align: 'center',
                        width: 60
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t5'), // 创建日期
                        key: 'creationDate',
                        align: 'center',
                        sortable: true,
                        width: 130
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t2'), // 需求日期
                        key: 'needByDate',
                        align: 'center',
                        sortable: true,
                        width: 130
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t53'), // 车牌号
                        key: 'vehicleNumber',
                        align: 'center',
                        sortable: true,
                        width: 130
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t19'), // 接收日期
                        key: 'receivedDate',
                        align: 'center',
                        sortable: true,
                        width: 130
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t33'), // 实收数量
                        key: 'receivedQuantity',
                        align: 'right',
                        sortable: true,
                        width: this.$i18n.locale === 'en-US' ? 170 : 100
                    },
                    {
                        title: this.$t('createMaterialLabel.status'), // 单据状态
                        key: 'deliveryStatus',
                        align: 'center',
                        width: 50
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t1'), // 库存组织
                        key: 'organizationCode',
                        align: 'center',
                        width: this.$i18n.locale === 'en-US' ? 100 : 50
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t15'), // 厂区
                        key: 'locationCode',
                        sortable: true,
                        width: 110,
                        tooltip: true
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t18'), // 车间
                        key: 'departmentCode',
                        align: 'center',
                        sortable: true,
                        width: this.$i18n.locale === 'en-US' ? 90 : 60
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t26'), // 仓管员
                        key: 'warehouseworkers',
                        align: 'center',
                        sortable: true,
                        width: this.$i18n.locale === 'en-US' ? 150 : 100
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t31'), // 作业号
                        key: 'wipentityNames',
                        sortable: true,
                        width: 150,
                        tooltip: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t19'), // 生产线
                        key: 'prodLineDesc',
                        width: 150,
                        sortable: true,
                        tooltip: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t20'), // 作业上线时间
                        key: 'scheduledStartDate',
                        align: 'center',
                        width: 140,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t37'), // 订单号
                        key: 'poNumber',
                        sortable: true,
                        width: 120
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t38'), // 订单行号
                        key: 'poLineNumber',
                        align: 'center',
                        width: this.$i18n.locale === 'en-US' ? 110 : 60
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t35'), // 项目号
                        key: 'projectNumber',
                        sortable: true,
                        width: 130
                    },
                    // {
                    //     title: this.$t('purchaseDistribution.hwdjh'), // 海外单据号
                    //     key: 'outsideNum',
                    //     align: 'center',
                    //     sortable: true,
                    //     width: 120
                    // },
                    {
                        title: this.$t('deliveryNoticeConfirm.t31'), // 说明
                        key: 'comments',
                        width: 120
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t18'), // 报关单号
                        key: 'customsDeclarationNumber',
                        width: 120,
                        width: this.$i18n.locale === 'en-US' ? 200 : 120
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t54'), // 打印次数
                        key: 'printAmount',
                        align: 'center',
                        sortable: true,
                        width: this.$i18n.locale === 'en-US' ? 100 : 50
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t30'), // 采购说明
                        key: 'purchaseApplyExplain',
                        width: 300
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t28'), // 创建人
                        key: 'createdBy',
                        align: 'center',
                        width: 120
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t29'), // 作业状态
                        key: 'meaning',
                        align: 'center',
                        width: 60,
                        width: this.$i18n.locale === 'en-US' ? 70 : 60
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t56'), // 箱号
                        key: 'omsCtn',
                        align: 'center',
                        width: 100,
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t57'), // 发票号
                        key: 'omsInvoiceNo',
                        align: 'center',
                        width: 100,
                    },
			        {
			            title: this.$t('DeliveryOrderQuery.t65'), // 供方发票号
			            key: 'invoiceNumber',
			            align: 'center',
			            width: 100,
			        },
                    {
                        title: this.$t('deliveryNoticeConfirm.t47'), // MCO变更标识
                        key: 'plmMcoChangeCode',
                        width: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t48'), // MCO变更说明
                        key: 'plmMcoChangeRemark',
                        width: 100,
                        align: 'center',
                    },
                ]
            },
            tableData: [],
            tableButtons: {
                customButtons: []
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
                submitLoading: false
            },
            selection: [],
            isJdTemplate: false,
            isJdTAGTemplate: false,
            INT_TIME_ZONE: [],
			CUX_INT_PRINT_CLODED: [],
            CUX_I_EC_ORG: [],
        }
    },
    methods: {
        onSubmit (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageSizeChange (currentPage, pageSize) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        onSelectionChange (selection) {
            this.selection = selection;
        },
        onSearch () {
            this.loading = true;
            axios.post('/gscint/order/queryOrder', {
                ...this.getFormDataVModel(this.formData.items),
                vendorCode: this.vendorCode,
                pageIndex: this.settings.currentPage,
                pageSize: this.settings.pageSize,
                language: this.$i18n.locale
            })
            .then((res) => {
                this.selection = [];
                this.loading = false;
                let data = res.data.data;
                if (data.code === '1') {
                    this.tableData = data.datas.list;
                    this.settings.total = data.datas.total;
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        beforeGetDelLocation1 () {
            this.getDelLocation();
        },
        /** 获取送货厂区 */
        getDelLocation () {
            this.locationSetting.loading = true;
            axios.post('/gscint/order/queryLocation', {
                organizationCode: this.orgCode,
                locationCode: this.locationSetting.inputValue,
                pageIndex: this.locationSetting.modalCurrentPage,
                pageSize: this.locationSetting.modalPageSize
            })
            .then((res) => {
                this.locationSetting.loading = false;
                let data = res.data.data.datas;
                if (data.list) {
                    this.locationSetting.modalTotalpages = data.total;
                    data.list.map((item) => {
                        item.hasSelected = false;
                        return item;
                    });
                    this.locationSetting.modalTableData = data.list;
                }
            })
            .catch(() => {
                this.locationSetting.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        handleSelect1 () {
            this.locationSetting.show = false;
            this.getFormDataItemObj(this.formData.items, 'locationCode').value = this.locationSetting.selectedRow.locationCode;
        },
        onModalPageChange1 (currentPage) {
            this.locationSetting.modalCurrentPage = currentPage;
            this.locationSetting.selectedRow = {};
            this.getDelLocation();
        },
        /** 获取送货子库 */
        getDelSubInv () {
            this.sublibrarySetting.loading = true;
            axios.post('/gscint/order/querySubinventory', {
                organizationCode: this.orgCode,
                invName: this.sublibrarySetting.inputValue,
                pageIndex: this.sublibrarySetting.modalCurrentPage,
                pageSize: this.sublibrarySetting.modalPageSize
            })
            .then((res) => {
                this.sublibrarySetting.loading = false;
                let data = res.data.data.datas;
                if (data.list) {
                    this.sublibrarySetting.modalTotalpages = data.total;
                    data.list.map((item) => {
                        item.hasSelected = false;
                        return item;
                    });
                    this.sublibrarySetting.modalTableData = data.list;
                }
            })
            .catch(() => {
                this.sublibrarySetting.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        beforeGetDelLocation2 () {
            this.getDelSubInv();
        },
        onModalPageChange2 (currentPage) {
            this.sublibrarySetting.modalCurrentPage = currentPage;
            this.sublibrarySetting.selectedRow = {};
            this.getDelSubInv();
        },
        handleSelect2 () {
            this.sublibrarySetting.show = false;
            this.getFormDataItemObj(this.formData.items, 'subinventory').value = this.sublibrarySetting.selectedRow.secondaryInventoryName;
        },
        beforeGetDelLocation3 () {
            this.getDelDept();
        },
        handleSelect3 () {
            this.departmentSetting.show = false;
            this.getFormDataItemObj(this.formData.items, 'departmentCode').value = this.departmentSetting.selectedRow.DEPARTMENT_CODE;
        },
        onModalPageChange3 (currentPage) {
            this.departmentSetting.modalCurrentPage = currentPage;
            this.departmentSetting.selectedRow = {};
            this.getDelDept();
        },
        // 车间
        getDelDept () {
            this.departmentSetting.loading = true;
            axios.post('/gscint/order/queryDepartment', {
                organizationCode: this.orgCode,
                departmentCode: this.departmentSetting.inputValue,
                pageIndex: this.departmentSetting.modalCurrentPage,
                pageSize: this.departmentSetting.modalPageSize
            })
            .then((res) => {
                this.departmentSetting.loading = false;
                let data = res.data.data.datas;
                if (data.list) {
                    this.departmentSetting.modalTotalpages = data.total;
                    data.list.map((item) => {
                        item.hasSelected = false;
                        return item;
                    });
                    this.departmentSetting.modalTableData = data.list;
                }
            })
            .catch(() => {
                this.departmentSetting.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        // 导出
        exportExcel () {
            if (this.$refs.pageForm.$refs.queryForm.validateForm()) {
                this.loading = true;
                window.open(`/gscint/order/exportOrder?paraJson=${encodeURI(JSON.stringify(
                    {
                        ...this.getFormDataVModel(this.formData.items),
                        vendorCode: this.vendorCode
                    }
                ))}`);
                setTimeout(() => {
                    this.loading = false;
                }, 5000);
            }
        },
        // 检验是否已存在
        async checkExistSxInspection(selection) {
            if (selection.length) {
                let orgCode = selection[0].organizationCode
                let vendorCode = selection[0].vendorCode
                let url = `/gscint/sxInspection/checkExistSxInspection?orgCode=${orgCode}&vendorCode=${vendorCode}`
                let itemCodeArr = selection.map(item => item.itemCode)
                let res = await axios.post(url, itemCodeArr)
                return res.data.data
            }
        },
        /** 判断校验 */
        async moreBeforePrint() {
            // let allOpenFlag = true; // 是否全部OPEN状态
            let repeatPrintFLag = false; // 是否重复打印
            let repeatBarcodeNumbers = new Set();
            const selection = this.$refs.pageForm.$refs.iTable.$refs.iTable.getSelection();
            let isCheckAll = 0
            selection.forEach((item) => {
                // /* CUX_INT_PRINT_CLODED字典存在有效值则不允许非打开状态的送货单打印 */
                // if (item.deliveryStatus !== 'OPEN' && this.CUX_INT_PRINT_CLODED.length > 0) {
                //     allOpenFlag = false;
                // }
                if (item.printTimes !== '0') {
                    repeatPrintFLag = true;
                    repeatBarcodeNumbers.add(item.barcodeNumber);
                }
                // 判断检是否已检验
                const { hasMatchReportQty, deliveryQuantity } = item;
                const isChecked = hasMatchReportQty === Number(deliveryQuantity);
                if (isChecked) {
                    isCheckAll += 1 
                }
            });
            // 所有勾选都完成检验
            // 1.如果已经匹配了首检报告(即页面中“检验”列为蓝色的记录），则不需要调用以上接口，直接打印送货单。
            // 2.如果没有匹配首检报告(即页面中“检验”列为灰色的记录），则先调用以上接口校验，如果返回校验成功，则继续执行打印送货单的逻辑；如果返回校验失败，则将返回的错误信息，作为弹出框信息，并提供取消和确认按钮
            if (isCheckAll !== selection.length) {
                let checkRes = await this.checkExistSxInspection(selection)
                console.log('checkRes',checkRes)
                if (checkRes.success) {
                    this.moreBeforePrintFn(selection, repeatPrintFLag, repeatBarcodeNumbers)
                } else {
                    let validItemCode = checkRes.datas
                    let currRow = selection.find(i => (i.itemCode == validItemCode))
                    if (currRow) {
                        this.$Modal.confirm({
                            content: checkRes.msg,
                            onOk: () => {
                                let { organizationId, organizationCode, organizationName, itemCode, itemName} = currRow
                                sessionStorage.setItem('orderMatchReport', JSON.stringify({
                                    list:  [currRow],
                                    orgId: organizationId,
                                    orgCode: organizationCode,
                                    orgName: organizationName,
                                    itemCode,
                                    itemName,
                                }));
                                this.$router.push({
                                    name: 'processInspectionMatch',
                                    query: {
                                        orgId: organizationId,
                                        itemCode: itemCode,
                                    }
                                });
                            }
                        })
                    }
                }
            } else {
                this.moreBeforePrintFn(selection, repeatPrintFLag, repeatBarcodeNumbers)
            }
        },
        async moreBeforePrintFn(selection, repeatPrintFLag, repeatBarcodeNumbers) {
            /* 取消状态或者已关闭状态禁止打印。否则提示“取消状态或者已关闭状态送货单禁止打印！
	            CUX_INT_PRINT_CLODED字典配置的组织允许取消或已关闭状态的送货单打印
	            OPEN状态打印次数限制，打印次数大于0的再次打印提示“ 送货单【送货单条码号】存在已打印情况，相同条码号不能被重复使用，请确认是否重复打印！
	        */
            if (selection.some((item) => item.deliveryStatus !== 'OPEN') && !this.CUX_INT_PRINT_CLODED.some((item) => item.code === selection[0].organizationCode)) {
                this.$Modal.error({
                    content: this.$t('DeliveryOrderQuery.t59'),
                });
                return;
            }
            // 校验勾选的送货单是否维护车牌号
            const vehicleNumberArr = selection.filter(item => (!item.vehicleNumber));
            if (this.carPlateNumSetting.isCar && vehicleNumberArr.length > 0) {
                this.$Modal.error({
                    content: this.$t('DeliveryOrderQuery.t49'),
                });
                return false;
            }
            await this.ecConfirm(selection);
            if (repeatPrintFLag) {
                this.$Modal.confirm({
                    content: `${this.$t('DeliveryOrderQuery.t60')}${[...repeatBarcodeNumbers].join()}${this.$t('DeliveryOrderQuery.t64')}`,
                    // okText: '取消',
                    // cancelText: '确定',
                    onOk: () => {
                        this.beforPrint();
                    }
                })
            } else {
                this.beforPrint();
            }
        },
        /** 获取打印的数据 */
        queryPrintOrderData() {
            this.loading = true;
            let newArr = [];
            this.selection.forEach(val => {
                newArr.push(val.barcodeNumber);
            });
            newArr = Array.from(new Set(newArr));
            let params = {
                barCodeNumberIn: newArr.join(','),
                language: 'en-US', // "US"
                orgCode: this.orgCode
            };
            return new Promise(resolve => {
                axios.post('/gscint/order/queryPrintOrderData', params).then(res => {
                        this.loading = false;
                        let rep = res.data;
                        if (rep.data.success === true) {
                            if (rep.data.datas.length > 0) {
                                let dict = this.INT_TIME_ZONE.find((item) => item.code === rep.data.datas[0].organizationCode);
                                if (dict) {
                                    rep.data.datas.forEach((head) => {
                                        // head.lineList && head.lineList.forEach((item) => {
                                        //     if (item.needByDate) {
                                        //         item.needByDate = moment(item.needByDate).add(dict.value, 'h').format('MM-DD HH:mm');
                                        //     }
                                        //     if (item.scheduledStartDate) {
                                        //         item.scheduledStartDate = moment(item.scheduledStartDate).add(dict.value, 'h').format('MM-DD HH:mm');
                                        //     }
                                        // });
				                        // /* 打印时间进行时区转换 */
				                        // if (head.currentTime) {
				                        //     head.printDate = moment(head.currentTime).add(dict.value, 'h').format('YYYY-MM-DD HH:mm');
				                        // }
                                        head.printDate = head.currentTime;
                                    });
                                }
                                resolve(rep.data.datas);
                            }
                        } else {
                            this.$Modal.error({
                                title: this.$t('common.warn'),
                                content: rep.data.msg
                            });
                        }
                    }
                ).catch(() => {
                    this.loading = false;
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                });
            });
        },
        floatAdd(arg1, arg2) {
            let r1; let r2; let m;
            try {
                r1 = arg1.toString().split('.')[1].length;
            } catch (e) {
                r1 = 0;
            }
            try {
                r2 = arg2.toString().split('.')[1].length;
            } catch (e) {
                r2 = 0;
            }
            m = Math.pow(10, Math.max(r1, r2));
            return (arg1 * m + arg2 * m) / m;
        },
        // 打印
        beforPrint() {
            this.queryPrintOrderData().then(rep => {
                let params1 = [];
                let params2 = [];
                let cpt = '';
                for (let i = 0; i < rep.length; i++) {
                    const { formType } = rep[i];
                    if (formType === 'NOTIFY') {
                        params1.push(rep[i]);
                    } else if (formType === 'PO') { // formType是PO，订单回货
                        params2.push(rep[i]);
                    }
                }
                if (params1.length > 0) {
                    if (this.isJdTemplate) {
                        cpt = 'hw-waterorder-nt-wl';
                    } else {
                        cpt = 'hw-waterorder-nt';
                    }
                    /** 云打印 */
                    this.loading = true;
                    /** 帆软打印 */
                    params1 = params1.map((item) => {
                        item.p1 = item.lineList;
                        let total = 0;
                        item.lineList.forEach((item2) => {
                        total = this.floatAdd(total, Number(item2.deliveryQuantity));
                        });
                        item.total = total;
                        return item;
                    });
                    if (!this.isCloundPrint({reportlets: params1}, params1[0].organizationCode, this.vendorCode, [], cpt)) {
                        this.printOrder(params1, `srm/${cpt}.cpt`);
                    } else {
                        this.loading = false;
                    }
                    }
                    if (params2.length > 0) {
                    if (this.isJdTemplate) {
                        cpt = 'hw-waterorder-po-wl';
                    } else {
                        cpt = 'hw-waterorder-po';
                    }
                    /** 云打印 */
                    this.loading = true;
                    /** 帆软打印 */
                    params2 = params2.map((item) => {
                        item.p1 = item.lineList;
                        let total = 0;
                        item.lineList.forEach((item2) => {
                        total = this.floatAdd(total, Number(item2.deliveryQuantity));
                        });
                        item.total = total;
                        return item;
                    });
                    if (!this.isCloundPrint({reportlets: params2}, params2[0].organizationCode, this.vendorCode, [], cpt)) {
                        this.printOrder(params2, `srm/${cpt}.cpt`);
                    } else {
                        this.loading = false;
                    }
                }
            });
        },
        /** 打印送货单 */
        printOrder(params, cpt) {
            console.log('params::', params);
            console.log('cpt:', cpt);
            this.loading = true;
            window.printWindow = window.open();
            this.$mprint.doURLPDFprint({
                cpt: cpt,
                data: params,
                printType: 'diePay'
            });
            setTimeout(() => {
                this.loading = false;
            }, 100);
        },
        /** 打印单条标签 */
        beforePrintSingleLabel(lineData) {
            let { barcodeNumber, itemCode, wipEntityId, organizationCode } = lineData;
            let barcodes = [];
            barcodes.push({
                deliveryBarcode: barcodeNumber,
                itemCode: itemCode,
                wipEntityId: wipEntityId,
                orgCode: organizationCode
            });
            this.getPrintList(barcodes).then(rep => {
                this.printLabel(rep, organizationCode);
            });
        },
       /** 打印 */
        printLabel(printData, orgCode) {
            this.loading = true;
            let cpt = '';
            let tempCode = '';
            if (this.isJdTAGTemplate) {
                tempCode = 'THAI_EM_TAG';
                /* 是否启用云打印 */
                if (!this.isCloundPrint({reportlets: printData}, orgCode, this.vendorCode, [], tempCode)) {
                    cpt = `srm/THAI_EM_TAG${this.isPro() ? '' : '_UAT'}.cpt`;
                    const config = {
                        cpt,
                        data: printData,
                        printType: 'diePay',
                    };
                    setTimeout(() => {
                        window.printWindow = window.open();
                        this.$mprint.doURLPDFprint(config);
                    }, 100);
                }
            } else {
                tempCode = 'INT_TAG_TEST';
                this.cloudPrint(tempCode, { reportlets: printData });
            }
            this.loading = false;
        },
        /** 获取打印的数据 */
        getPrintList(barcodes) {
            this.loading = true;
            let url = `/gscint/itemTagInt/${this.isJdTAGTemplate ? 'queryThaiEmTagPrintList' : 'getPrintList'}`;
            return new Promise(resolve => {
                axios.post(url, barcodes).then(res => {
                        this.loading = false;
                        let rep = res.data;
                        if (rep.data.success === true) {
                            if (this.isJdTAGTemplate) {
                                if (rep.data.datas.length > 0) {
                                    resolve(rep.data.datas);
                                }
                            } else {
                                if (rep.data.data.rows.length > 0) {
                                    resolve(rep.data.data.rows);
                                }
                            }
                        } else {
                            this.$Modal.error({
                                title: this.$t('common.warn'),
                                content: rep.data.msg
                            });
                        }
                    }
                ).catch(() => {
                    this.loading = false;
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                });
            });
        },
        /** 判断`取消`状态的送货单不能维护物料标签 */
        validStatus(pageSize) {
            let returnStatus = true;
            if (this.selection.length > 0) {
                let statusArr = this.selection.filter(item => (item.deliveryStatus === 'CANCEL'));
                if (statusArr.length > 0) {
                    this.$Modal.warning({
                        title: this.$t('common.warn'),
                        content: this.$t('DeliveryOrderQuery.t44')
                    });
                    returnStatus = false;
                }
            }
            return returnStatus;
        },
        /** 跳转到物料标签，传参去重 */
        toMaterialLabel() {
            if (!this.validStatus()) {
                return false;
            }
            let newArr = [];
            this.selection.forEach(val => {
                newArr.push(val.barcodeNumber);
            });
            let barcodes = Array.from(new Set(newArr));
            let ob = this.selection[0];
            let params = {
                orgCode: ob.organizationCode,
                orgId: ob.organizationId,
                orgName: ob.organizationName,
                barcodes
            };
            this.$router.push({
                path: '/purchaseDistribution/createMaterialLabel',
                query: {
                    orderParams: JSON.stringify(params)
                }
            });
        },
        /** 维护车牌号 */
        maintainCarPlateNum() {
            this.carPlateNumSetting.inputValue = '';
            this.carPlateNumSetting.show = true;
        },
        carPlateNumSettingOk() {
            let hasVehicleNumberArr = [];
            this.selection.forEach((item) => {
                if (!!item.vehicleNumber) {
                    hasVehicleNumberArr.push(item.vehicleNumber);
                }
            });
            if (hasVehicleNumberArr.length > 0) {
                this.$Modal.confirm({
                    title: this.$t('common.warn'),
                    content: `${this.$t('DeliveryOrderQuery.t50')}${hasVehicleNumberArr.join('、')}，${this.$t('DeliveryOrderQuery.t51')}`,
                    onOk: () => {
                        setTimeout(() => {
                            this.saveOrderVehicleNumber();
                        }, 300);
                    }
                });
            } else {
                this.saveOrderVehicleNumber();
            }
        },
        saveOrderVehicleNumber() {
            let newArr = [];
            this.selection.forEach(val => {
                newArr.push(val.barcodeNumber);
            });
            this.loading = true;
            axios.post('/gscint/order/saveOrderVehicleNumber', {
                barcodeNumbers: newArr.join(','),
                vehicleNumber: this.carPlateNumSetting.inputValue
            }).then(res => {
                this.loading = false;
                let rep = res.data;
                if (rep.data.success === true) {
                    this.carPlateNumSetting.show = false;
                    this.$Modal.success({
                        content: this.$t('DeliveryOrderQuery.t48')
                    });
                    this.onSearch();
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: rep.data.msg
                    });
                }
            }).catch(err => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1'),
                    error: err.stack.toString()
                });
            });
        },
	    goInvoice () {
	        this.$router.push({
	            name: 'invoiceMonitoring'
	        });
	    },
	    /* 匹配检验报告 */
	    async matchReport() {
	        let itemCodes = [];
            this.selection.forEach(({itemCode}) => {
                if (!itemCodes.includes(itemCode)) {
                    itemCodes.push(itemCode);
                }
            });
	        if (itemCodes.length > 1) {
	            this.$Modal.warning({
	                content: this.$t('请勾选相同物料编码的送货单'),
	            });
	            return;
	        }
	        if (this.selection.some((item) => item.hasMatchReportQty === parseFloat(item.deliveryQuantity))) {
	            this.$Modal.warning({
	                content: this.$t('processInspectionSearch.t113'), // 送货单已经匹配，不允许再进行匹配操作
	            })
	            return;
	        }
            // await this.checkHsNext();
            let {organizationId, organizationCode, organizationName, itemCode, itemName} = this.selection[0];
            sessionStorage.setItem('orderMatchReport', JSON.stringify({
                list:  this.selection,
                orgId: organizationId,
                orgCode: organizationCode,
                orgName: organizationName,
                itemCode,
                itemName,
            }));
	        this.$router.push({
	            name: 'processInspectionMatch',
	            query: {
	                orgId: organizationId,
	                itemCode: itemCode,
	            }
	        });
	    },
        /* 物料变更确认校验 */
        ecConfirm(selection) {
            return new Promise((resolve, reject) => {
                const { organizationId: orgId } = selection[0];
                if (this.CUX_I_EC_ORG.find((item) => item.value === orgId)) {
                    axios.post('/gscint/order/deliver/checkOrgAndEcChange', [
                        {
                            vendorCode: this.vendorCode,
                            itemCode: this.selection.map((item) => item.itemCode).join(),
                            orgId,
                        },
                    ])
                        .then((res) => {
                            const { code } = res.data.data;
                            if (code === '0') {
                                this.$Modal.confirm({
                                    content: this.$t('supplierEcConfirm.t21'), // 存在未确认的物料变更单，请立即确认
                                    onOk: () => {
                                        this.$router.push({
                                            name: 'supplierEcConfirm'
                                        });
                                    },
                                })
                                reject();
                            } else {
                                resolve();
                            }
                        })
                        .catch(() => {
                            resolve();
                        });
                } else {
                    resolve();
                }
            });
        },
        setTableUpdate(columns) {
            this.columns.columns = columns;
        },
        /* 创建发货清单 */
        submitShipping() {
            if (this.selection.some((item) => ['INT_SHIPPED', 'INT_SUBMITTED'].includes(item.deliveryListStatus))) {
                this.$Modal.warning({
                    content: this.$t('送货单不允许重复创建发货清单'),
                });
                return;
            }
            if (this.selection.some(item => !item.subInventory) || new Set(this.selection.map(item => item.subInventory)).size > 1) {
                this.$Modal.warning({
                    content: '子库不能为空或子库不唯一',
                });
                return;
            }
            this.$Modal.confirm({
                content: this.$t('确定要创建发货清单吗？'),
                onOk: () => {
                    this.loading = true;
                    setTimeout(() => {
                        axios.post('/gscint/order/submitShipping', {
                            deliveryHeaderIdList: this.selection.map((item) => item.deliveryHeaderId),
                            vendorCode: this.vendorCode,
                        })
                            .then((res) => {
                                const { code, msg: content } = res.data.data;
                                if (code == '1') {
                                    this.$Modal.success({
                                        content: this.$t('gscInvoice.t100'),
                                    });
                                    this.onSearch();
                                } else {
                                    this.$Modal.warning({
                                        content,
                                    });
                                }
                            })
                            .catch(() => {
                                _this.showErrorTips();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    }, 400);
                },
            });
        },
        /* 取消发货清单 */
        cancelShipping() {
            if (this.selection.some((item) => item.deliveryListStatus !== 'INT_SUBMITTED')) {
                this.$Modal.warning({
                    content: this.$t('发货清单状态必须为已提交，才可以取消'),
                });
                return;
            }
          this.$Modal.confirm({
                content: this.$t('确定要取消发货清单吗？'),
                onOk: () => {
                    this.loading = true;
                    setTimeout(() => {
                        axios.post('/gscint/order/cancelShipping', {
                            vendorCode: this.vendorCode,
                            deliveryHeaderIdList: Array.from(new Set(this.selection.map((item) => item.deliveryHeaderId))),
                        })
                            .then((res) => {
                                const { code, msg: content } = res.data.data;
                                if (code == '1') {
                                    this.$Modal.success({
                                        content: this.$t('gscInvoice.t110'),
                                    });
                                    this.onSearch();
                                } else {
                                    this.$Modal.warning({
                                        content,
                                    });
                                }
                            })
                            .catch(() => {
                                _this.showErrorTips();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    }, 400);
                },
            });
        },
        /* 发货清单查询 */
        shippingList() {
            this.deliveryListModal.loading = true;
            const { deliveryListPrinted, deliveryListStatus } = this.deliveryListModal;
            axios.post('/gscint/order/shippingList', {
                vendorCode: this.vendorCode,
                orgCode: this.orgCode,
                deliveryListPrinted,
                deliveryListStatus,
            })
                .then((res) => {
                    const { code, datas, msg: content } = res.data.data;
                    if (code === '1') {
                        datas.forEach((item) => {
                            item.selected = false;
                        });
                        this.deliveryListModal.tableData = datas;
                    } else {
                        this.$Modal.warning({
                            content,
                        });
                    }
                })
                .finally(() => {
                    this.deliveryListModal.loading = false;
                });
        },
        deliveryListModalOpen() {
            debugger;
            if (!this.$refs.pageForm.validateFieldForm(0)) {
                this.deliveryListModal.show = true
            }
        },
        exportShippingList() {
            debugger;
            this.deliveryListModal.loading = true;
            exportExcel('/gscint/order/exportShippingList', {
                orgCode: this.orgCode,
                vendorCode: this.vendorCode,
                deliveryListNumber: this.deliveryListModal.row.deliveryListNumber,
                language: this.$i18n.locale,
            }, `${this.$t('供应商提交发货') + moment().format('YYYY-MM-DD')}.xlsx`, this)
                .finally(() => {
                    this.deliveryListModal.loading = false;
                });
        },
        /** 根据相同的itemCode和barcodeNumber查找关联的数据 */
        getDelOrderInfoListByBarList: function () {
            return new Promise(resolve => {
                let params = [];
                for (let i = 0; i < this.selection.length; i++) {
                    params.push({
                        itemCode: this.selection[i].itemCode,
                        barCodeNumber: this.selection[i].barcodeNumber,
                        vendorCode: this.selection[i].vendorCode
                    });
                }
                let url = '/gscint/order/getDelOrderInfoListByBarList';
                axios.post(url, params).then(
                    res => {
                        if (res.data.success === true) {
                            resolve(res.data.data);
                        } else {
                            this.$Modal.error({
                                title: this.$t('common.warn'),
                                content: res.data.msg
                            });
                        }
                    }
                ).catch(() => {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                });
            });
        },
        async checkHsNext () {
            this.getDelOrderInfoListByBarList().then(rep => {
                this.allRelateData = rep;
                if (rep.length > this.selection.length) {
                    this.$Modal.confirm({
                        title: this.$t('提示'),
                        content: this.$t('存在相关联的送货单未勾选，是否继续操作？'),
                        onOk: () => {
                            // this.checkDisqualification().then(() => {
                            //     this.RisSupplierReworkCheck();
                            // });
                        }
                    });
                    this.hasSameDelivery = true;
                } else {
                    this.hasSameDelivery = false;
                }
            });
        },
    },
    mounted () {
        this.getSRMInvLovListNew((data) => {
            let list = [];
            data.forEach((item) => {
                list.push({
                    label: item.organizationName,
                    value: item.organizationCode
                });
            });
            this.getFormDataItemObj(this.formData.items, 'orgCode').options.values = list;
        });
        this.getDict('INT_deliveryOrderStatus', (data) => {
            this.getFormDataItemObj(this.formData.items, 'deliveryStatus').options.values = data;
        });
        this.getDict('INT_DELIVERYORDERTYPE', (data) => {
            this.getFormDataItemObj(this.formData.items, 'formType').options.values = data;
        });
        this.getDict('INT_MAKEORDERSTATUS', (data) => {
            this.getFormDataItemObj(this.formData.items, 'wipstatus').options.values = data;
        });
        this.getDict('INT_VEHICLE_NO');
        // GAT泰国机电送货单打印快码
        this.getDict('INT_CUX_DELIVERY_TEMPLATE');
        // GAT泰国机电标签打印快码
        this.getDict('INT_CUX_ITEM_TAG_TEMPLATE');
        /* 时区转换 */
        this.getDict('INT_TIME_ZONE');
	    /* 未维护、失效不允许打印 */
	    this.getDict('CUX_INT_PRINT_CLODED');
        /* 物料变更确认校验开关 */
        this.getDict('CUX_I_EC_ORG');
        /* 发货清单状态 */
        this.getDict('INT_DELIVERY_LIST_STATUS', (data) => {
            this.getFormDataItemObj(this.formData.items, 'deliveryListStatus').options.values = data;
        });
        this.getDict('INT_HW_DELIVERY_LIST');
    }
}
</script>
<style lang="less" scoped>
.mr10 {
    margin-right: 10px;
}
</style>
